export default __webpack_public_path__ + "static/media/PW.2f97be4f.svg";